module.exports = __webpack_public_path__ + "images/play.png?v=b8764fa6cfb8c00e6765c480fb6850dd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/play.png
// module id = 624
// module chunks = 0